import React from "react";
import "./ToolsGrid.css";

const ToolsGrid = () => {
  const categories = [
    {
      id: "data",
      title: "Data",
      emoji: "📊",
      description: "Analyzing and visualizing data to uncover insights.",
      tech: ["Python", "SQL", "Tableau", "Excel"]
    },
    {
      id: "design",
      title: "Design",
      emoji: "🎨",
      description: "Creating beautiful, user-centered interfaces.",
      tech: ["Figma", "HTML/CSS", "JavaScript", "React"]
    },
    {
      id: "develop",
      title: "Development",
      emoji: "💻",
      description: "Building functional, scalable web applications.",
      tech: ["Java", "Python", "TypeScript", "React", "Git"]
    }
  ];

  return (
    <div className="tools-grid-container">
      <div className="tools-grid">
        {categories.map((category) => (
          <div key={category.id} className="tool-category-card">
            <div className="tool-card-icon">{category.emoji}</div>
            <h3 className="tool-card-title">{category.title}</h3>
            <p className="tool-card-description">{category.description}</p>
            <div className="tool-card-tech">
              {category.tech.map((tech, idx) => (
                <span key={idx} className="tech-chip">{tech}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToolsGrid;

